export default __webpack_public_path__ + "static/media/spinner-small.952dc259.gif";